module.exports = __webpack_public_path__ + "28b8c158347dba2fed728a76bc81ad0b.svg";